<template>
  <TableauLayout>
    <div class="overflow-x" v-horizontal-scroll>
      <FixedPlaceholder :component="TableauHorizontalMenu" :hideBackToTop="true" :workbookSheets="workbookSheets" :activeSheet="activeSheet" horizontal @undo="undoAction" @reset-filters="resetFilters" />
      <div class="container m-0 p-0" v-if="modelData">
        <TableauCloudView :modelData="modelData" :filterName="filterName" :availableParameters="availableParameters" :availableFilters="availableFilters" ref="tableauView" v-if="getFlag('DAS-1759')" />
        <TableauView :modelData="modelData" :filterName="filterName" :availableParameters="availableParameters" :availableFilters="availableFilters" ref="tableauView" v-else />
      </div>
      <Loader v-else />
    </div>
  </TableauLayout>
</template>

<script>
import { errorDebug, } from '../../../libraries/common';
import axios from '../../../axios';
import TableauLayout from '../../../components/tableau/TableauLayout.vue';
import TableauHorizontalMenu from '../../../components/tableau/TableauHorizontalMenu.vue';
import FixedPlaceholder from '../../../components/common/fixedPlaceholder/FixedPlaceholder.vue';
import TableauCloudView from '../../../components/tableau/TableauCloudView.vue';
import TableauView from '../../../components/tableau/TableauView.vue';
import moment from 'moment';
export default {
  title: 'Medinsights',
  components: { TableauLayout, FixedPlaceholder, TableauCloudView, TableauView, },
  data() {
    let workbookSheets = {
      'EXECUTIVE SUMMARY': [{ text: 'EXECUTIVE SUMMARY', url: '/MedInsights/EXECUTIVESUMMARY/EXECUTIVESUMMARY' }],
      'CASE VOLUME': [
        { text: 'ALL CASE TYPES', url: '/MedInsights/ALLCASETYPES/ALLCASETYPES' },
        { text: 'MI CASES', url: '/MedInsights/MICASES/MICASES' },
        { text: 'AE REPORT', url: '/MedInsights/AEREPORT/AEREPORT' },
        { text: 'PC REPORT', url: '/MedInsights/PCREPORT/PCREPORT' }
      ],
    }
    if (this.getFlag('medinsights-phone-metrics-dashboard')) {
      workbookSheets['PHONE METRICS'] = [{ text: 'PHONE METRICS', url: '/MedInsights/PHONEMETRICS/PHONEMETRICS' }]
    }

    var formatDate = date => moment.utc(date).format('YYYY-MM-DD');
    var availableParameters = {
      'Date Range': f => f.formattedValue,
      'Earliest Date': f => formatDate(f.value),
      'Latest Date': f => formatDate(f.value),
    };
    var availableFilters = ['Organization', 'Date Range', 'Case Product1'];

    return {
      workbookSheets,
      filterName: 'medinsightsSelectedFilters',
      availableParameters,
      availableFilters,
      modelData: null,
      TableauHorizontalMenu,
    };
  },
  computed: {
    activeSheet() {
      var firstUrl = Object.values(this.workbookSheets).flatMap(f => f).find(f => f.url).url;
      return this.$route.params.sheet || firstUrl.split('/').head().last();
    },
    dashboardTokenUrl() {
      if (this.getFlag('DAS-1759')) {
        return `/Medinsights/SCIPHER/${this.activeSheet}/${this.activeSheet}/TableauCloudDashboardModel`;
      } else {
        return `/Medinsights/SCIPHER/${this.activeSheet}/${this.activeSheet}/TableauDashboardModel`;
      }
    },
  },
  methods: {
    getData() {
      this.modelData = null;
      axios.get(this.dashboardTokenUrl)
        .then(response => {
          this.modelData = response.data;
          this.$nextTick(this.initViz);
        })
        .catch(err => {
          this.modelData = {};
          errorDebug(err);
        });
    },
    undoAction() {
      this.$refs.tableauView?.undoAction();
    },
    resetFilters() {
      this.$refs.tableauView?.resetFilters();
    },
  },
  watch: {
    $route() {
      this.getData();
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisMedinsights'] = this;

    this.getData();
  },
}
</script>
